// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3_kRq","productName":"Table_productName__3bY3W"};